import { render, staticRenderFns } from "./DetailForAlbum.vue?vue&type=template&id=0455f940&scoped=true&"
import script from "./DetailForAlbum.vue?vue&type=script&lang=js&"
export * from "./DetailForAlbum.vue?vue&type=script&lang=js&"
import style0 from "./DetailForAlbum.vue?vue&type=style&index=0&id=0455f940&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0455f940",
  null
  
)

export default component.exports